module.exports = __webpack_public_path__ + "img/bg_ghost_05@3x.1c5914c9.png";